import * as types from '../mutation-types'
import * as api from '../api'
import _ from 'lodash'

const state = {
  images: []
}

const getters = {
  allImages: state => state.images,
}

const actions = {
  getImages ({ commit }) {
    return api.instance.get('images')
      .then(function (response) {
        let images = response.data.images

        for (let i = 0; i < images.length; i++) {
          images[i].alert = false
          images[i].announcement = false

          if (images[i].tags.includes('alert')) {
            images[i].alert = true
          }

          if (images[i].tags.includes('announcement')) {
            images[i].announcement = true
          }
        }

        commit(types.RECEIVE_IMAGES, images)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  uploadImage ({ commit }, data) {
    const file = data.file
    const tags = data.tags
    const name = data.name

    if(name.trim() === "") {
        alert("Please enter a name for the image")
        return
    }

    const formData = new FormData()
    formData.append('image', file)
    formData.append('name', name)

    let tagsStr = ''
    if (tags.alert) {
      tagsStr += 'alert,'
    }
    if (tags.announcement) {
      tagsStr += 'announcement,'
    }
    tagsStr = tagsStr.slice(0, -1)

    formData.append('tags', tagsStr)

    return api.instance.post('images', formData, { 'content-type': 'multipart/form-data' })
      .then(function (response) {
        if (response.data.success === 'true') {
          alert('Image file uploaded successfully!')

          response.data.image.alert = false
          response.data.image.announcement = false

          if (response.data.image.tags.includes('alert')) {
            response.data.image.alert = true
          }

          if (response.data.image.tags.includes('announcement')) {
            response.data.image.announcement = true
          }

          commit(types.UPLOAD_IMAGE, response.data.image)
          return true
        } else {
          alert(response.data.message)
        }
      })
  },
  editImage ({ commit }, image) {
    let tagsStr = ''
    if (image.alert) {
      tagsStr += 'alert,'
    }
    if (image.announcement) {
      tagsStr += 'announcement,'
    }
    tagsStr = tagsStr.slice(0, -1)

    image.tags = tagsStr

    if(image.name.trim() === '') {
        alert('Name is required')
        return false
    }

    return api.instance.put('images/' + image.image_id, image)
      .then(function (response) {
        if (response.data.success === 'true') {
            alert('Image updated successfully!')
        } else {
          alert(response.data.message)
        }
      })
  },
  deleteImage ({ commit }, image) {
    return api.instance.delete('images/' + image.image_id)
      .then(function (response) {
        alert(response.data.message)

        if (response.data.success === 'true') {
          commit(types.DELETE_IMAGE, image)
        }
      })
  }
}

const mutations = {
  [types.RECEIVE_IMAGES] (state, images) {
    state.images = _.orderBy(images, 'filename', 'asc')
  },
  [types.UPLOAD_IMAGE] (state, image) {
    state.images.push(image)
    state.images = _.orderBy(state.images, 'filename', 'asc')
  },
  [types.DELETE_IMAGE] (state, image) {
    state.images = state.images.filter(img => img.image_id !== image.image_id)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
